import {faMagnifyingGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Col, Row, Space, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {
    AiMonitoringBrandAnalysisType,
    AiMonitoringRunType,
} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';
import {AiMonitoringRunStatusTag} from '../../run-status-tag';

import {TONALITY_LANG_KEY_MAP, TONALITY_METRIC_COLOR, VISIBILITY_METRIC_COLOR} from './brand-analysis-const';
import {MetricCard} from './metric-card';
import * as styles from './metrics-hero.scss';

type PropsType = {
    run: AiMonitoringRunType;
    analysis: AiMonitoringBrandAnalysisType | undefined;
};

export function MetricsHero(props: PropsType): JSX.Element {
    const {run, analysis} = props;
    const {getLocalizedString} = useLocale();

    const signals = analysis?.visibility.signals ?? [];
    const foundCount = signals.filter((signal) => signal.found).length;
    const visibilityNote = getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__SIGNALS_FOUND', {
        found: String(foundCount),
        total: String(signals.length),
    });
    const overall = analysis?.tonality.overall;
    const overallNote = overall ? getLocalizedString(TONALITY_LANG_KEY_MAP[overall]) : '';

    return (
        <div>
            <Space align="center" className={styles.metrics_hero__source_note} size="small">
                <Typography.Text className={styles.metrics_hero__source_note_text} type="secondary">
                    <FontAwesomeIcon className={styles.metrics_hero__source_note_icon} icon={faMagnifyingGlass} />
                    <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__SOURCE_NOTE" />
                </Typography.Text>
                <AiMonitoringRunStatusTag status={run.status} />
            </Space>

            <Row gutter={[16, 16]}>
                <Col md={12} xs={24}>
                    <MetricCard
                        color={VISIBILITY_METRIC_COLOR}
                        delta={run.visibilityScoreDelta}
                        labelKey="AI_BRAND_MONITORING__ANALYSIS__VISIBILITY"
                        note={visibilityNote}
                        score={run.visibilityScore}
                        tooltip={getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__VISIBILITY_TOOLTIP')}
                    />
                </Col>
                <Col md={12} xs={24}>
                    <MetricCard
                        color={TONALITY_METRIC_COLOR}
                        delta={run.tonalityScoreDelta}
                        labelKey="AI_BRAND_MONITORING__ANALYSIS__TONALITY"
                        note={overallNote}
                        score={run.tonalityScore}
                        tooltip={getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__TONALITY_TOOLTIP')}
                    />
                </Col>
            </Row>
        </div>
    );
}
